<template>
    <main>
        <limitless-page-header
            :sub-title="(complaint && complaint.id > 0 ? '' : 'Skapa ny')"
            :title-id="(complaint && complaint.id > 0 ? complaint.id : '')"
        >
            <template #header-elements>
                <b-button variant="white" :to="{name: 'shipping.complaints.list'}">
                    <BIconListOl class="mr-1"></BIconListOl>
                    Lista
                </b-button>
            </template>
        </limitless-page-header>
        <div class="content">
            <b-card no-body>
                <b-card-header>
                    <b-badge v-if="complaint" variant="info">{{ complaint.status_label }}</b-badge>
                </b-card-header>
                <b-card-body>
                    <div v-if="complaint">
                        <ValidationObserver ref="form">
                            <b-form-group label="Skapad:"
                                          label-cols="2"
                                          label-align="right"
                                          aria-required="true"
                                          label-class="pt-0 pb-0"
                            >
                                <span>{{ complaint.created_at }}</span>
                            </b-form-group>
                            <b-form-group label="Uppdaterad:"
                                          label-cols="2"
                                          label-align="right"
                                          aria-required="true"
                                          label-class="pt-0 pb-0"
                            >
                                <span>{{ complaint.updated_at }}</span>
                            </b-form-group>
                            <b-form-group label="Skapad av:"
                                          label-cols="2"
                                          label-align="right"
                                          aria-required="true"
                                          label-class="pt-0 pb-0"
                            >
                                <span>{{ complaint.created_by.name }}</span>
                            </b-form-group>
                            <ValidationProvider vid="service_type"
                                                name="Servicetyp"
                                                rules="required"
                                                v-slot="{ errors }">
                                <b-form-group label="Servicetyp:"
                                              label-cols="2"
                                              label-align="right"
                                              aria-required="true"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <input type="text"
                                           readonly
                                           class="form-control"
                                           v-model="complaint.service_type">
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider vid="parcel_number"
                                                name="Trackingnummer"
                                                rules="required"
                                                v-slot="{ errors }">
                                <b-form-group label="Trackingnummer:"
                                              label-cols="2"
                                              label-align="right"
                                              aria-required="true"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <input type="text"
                                           readonly
                                           class="form-control"
                                           v-model="complaint.parcel_number">
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider vid="reference"
                                                name="Sändningsreferens"
                                                v-slot="{ errors }">
                                <b-form-group label="Sändningsreferens:"
                                              label-cols="2"
                                              label-align="right"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <input type="text"
                                           readonly
                                           class="form-control"
                                           v-model="complaint.reference">
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider vid="product_claim"
                                                name="Varuersättning"
                                                v-slot="{ errors }">
                                <b-form-group label="Varuersättning:"
                                              label-cols="2"
                                              label-align="right"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <input type="text"
                                           class="form-control"
                                           v-model="complaint.product_claim">
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider vid="freight_claim_type"
                                                name="Fraktersättning"
                                                v-slot="{ errors }">
                                <b-form-group label="Fraktersättning:"
                                              label-cols="2"
                                              label-align="right"
                                              aria-required="true"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <vue-select :options="config.freightClaimTypes"
                                                :clearable="false"
                                                :reduce="(type) => type.id"
                                                v-model="complaint.freight_claim_type">
                                    </vue-select>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider vid="description"
                                                name="Beskrivning"
                                                v-slot="{ errors }">
                                <b-form-group label="Beskrivning:"
                                              label-cols="2"
                                              label-align="right"
                                              aria-required="true"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <b-textarea type="text"
                                                rows="8"
                                                v-model="complaint.description"
                                    >
                                    </b-textarea>
                                </b-form-group>
                            </ValidationProvider>
                            <b-form-group label="Skickad:"
                                          label-cols="2"
                                          label-align="right"
                                          aria-required="true"
                                          label-class="pt-0 pb-0"
                            >
                                <span>{{ complaint.sent_at || '-' }}</span>
                            </b-form-group>
                            <b-form-group label="Påminnelse skickad:"
                                          label-cols="2"
                                          label-align="right"
                                          aria-required="true"
                                          label-class="pt-0 pb-0"
                            >
                                <span>{{ complaint.reminded_at || '-' }}</span>
                            </b-form-group>
                            <ValidationProvider vid="external_no"
                                                name="Externt ärendenummer"
                                                v-slot="{ errors }">
                                <b-form-group label="Externt ärendenummer:"
                                              label-cols="2"
                                              label-align="right"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <input type="text"
                                           class="form-control"
                                           v-model="complaint.external_no">
                                </b-form-group>
                                <b-form-group label="Externt ärendenummer registrerat:"
                                              label-cols="2"
                                              label-align="right"
                                              aria-required="true"
                                              label-class="pt-0 pb-0"
                                >
                                    <span>{{ complaint.external_no_received_at || '-' }}</span>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider vid="received_amount"
                                                name="Ersättningsbelopp"
                                                v-slot="{ errors }">
                                <b-form-group label="Ersättningsbelopp:"
                                              label-cols="2"
                                              label-align="right"
                                              label-class="pt-1"
                                              :invalid-feedback="getInvalidFeedback(errors)"
                                              :state="!errors.length"
                                >
                                    <input type="text"
                                           class="form-control"
                                           v-model="complaint.received_amount">
                                </b-form-group>
                                <b-form-group label="Ersättning registrerad:"
                                              label-cols="2"
                                              label-align="right"
                                              aria-required="true"
                                              label-class="pt-0 pb-0"
                                >
                                    <span>{{ complaint.resolved_at || '-' }}</span>
                                </b-form-group>
                            </ValidationProvider>
                        </ValidationObserver>
                    </div>
                </b-card-body>
                <b-card-footer>
                    <div v-if="complaint">
                        <b-row>
                            <b-col>
                                <b-button-group v-if="mode === 'view' && complaint.status !== 'resolved' && complaint.status !== 'closed'">
                                    <limitless-button v-if="complaint.status === 'new'" type="button" @click="generate" :busy="generating" icon="icon-file-pdf">Skapa PDF</limitless-button>
                                    <limitless-button v-if="complaint.status === 'new' && complaint.has_pdf" type="button" @click="send" :busy="sending" icon="icon-envelope" class="ml-2">Skicka</limitless-button>
                                    <limitless-button
                                        v-if="(complaint.status === 'sent' || complaint.status === 'reminded') && complaint.has_pdf"
                                        type="button"
                                        @click="send"
                                        :busy="sending"
                                        icon="icon-envelope">
                                        Skicka Påminnelse
                                    </limitless-button>
                                </b-button-group>
                            </b-col>
                            <b-col>
                                <b-button-group v-if="mode === 'view' && complaint.status !== 'resolved' && complaint.status !== 'closed'">
                                    <limitless-button type="button" @click="save('closed')" :busy="saving" icon="icon-floppy-disk">Spara och sätt som stängd</limitless-button>
                                    <limitless-button type="button" @click="save('resolved')" :busy="saving" icon="icon-floppy-disk" class="ml-2">Spara och sätt som löst</limitless-button>
                                </b-button-group>
                                <limitless-button v-if="mode === 'create'" type="button" @click="create" :busy="creating" icon="icon-floppy-disk" class="float-right">Skapa</limitless-button>
                                <limitless-button v-if="mode === 'view'" type="button" @click="save()" :busy="saving" icon="icon-floppy-disk" class="float-right">Spara</limitless-button>
                            </b-col>
                        </b-row>
                    </div>
                </b-card-footer>
                <floating-center-spinner :loading="loading">Hämtar data...</floating-center-spinner>
            </b-card>
            <b-card no-body v-if="complaint && complaint.has_pdf">
                <Iframe :src="pdfUrl"
                        frameborder="0"
                        style="width: 100%; height: 100vh; overflow-x: hidden;"
                >
                </Iframe>
            </b-card>
        </div>
    </main>
</template>

<script>

import ApiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import VueSelect from '@components/Wrappers/VueSelect.vue';
import getError from '@services/ErrorHelper';
import FloatingCenterSpinner from '@components/FloatingCenterSpinner.vue';
import Iframe from '@components/Iframe.vue';
import { BIconListOl } from 'bootstrap-vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';

export default {
    components: {
        LimitlessButton,
        Iframe,
        FloatingCenterSpinner,
        VueSelect,
        LimitlessPageHeader,
        BIconListOl,
    },
    data() {
        return {
            loading: false,
            config: {},
            id: this.$route.params.id ?? null,
            parcelId: this.$route.params.parcelId ?? null,
            complaint: null,
            mode: 'view',
            saving: false,
            creating: false,
            generating: false,
            sending: false,
            pdfUrl: '/vue/shipping/complaint/' + this.$route.params.id + '/pdf',
        };
    },
    created() {
        this.initConfig();
        if (this.$route.name === 'shipping.complaints.create') {
            this.mode = 'create';
        }
    },
    mounted() {
        if (this.mode === 'create') {
            this.hydrate();
            return;
        }

        this.fetch();
    },
    methods: {
        async initConfig() {
            const response = await ApiClient.get('/vue/shipping/complaint/config')
                .catch((error) => error.response || { data: {}, status: 500 });

            this.config = response.data.data ?? {};
        },
        async fetch() {
            this.loading = true;

            const response = await ApiClient.get('/vue/shipping/complaint/' + this.id)
                .catch((error) => error.response || { data: {}, status: 500 });

            this.loading = false;

            this.complaint = response.data.data ?? null;
        },
        async hydrate() {
            this.loading = true;

            const response = await ApiClient.get('/vue/shipping/complaint/hydrate/' + this.parcelId)
                .catch((error) => error.response || { data: {}, status: 500 });

            this.loading = false;

            this.complaint = response.data.data ?? null;
        },
        async create() {
            this.creating = true;

            const payload = JSON.parse(JSON.stringify(this.complaint));
            if (!payload.product_claim) {
                delete payload.product_claim;
            }
            const response = await ApiClient.post('/vue/shipping/complaint', payload)
                .catch((error) => {
                    const parsedError = getError(error);
                    if (typeof parsedError === 'object') {
                        this.$refs.form.setErrors(parsedError);
                    }

                    return error.response || { data: {} };
                });

            this.creating = false;

            if (response?.data?.data?.id) {
                this.$router.push({ name: 'shipping.complaints.view', params: { id: response.data.data.id } });
            }
        },
        async save(status) {
            this.saving = true;

            const payload = JSON.parse(JSON.stringify(this.complaint));
            if (!payload.product_claim) {
                delete payload.product_claim;
            }
            if (status) {
                payload.status = status;
            }
            const response = await ApiClient.patch('/vue/shipping/complaint/' + payload.id, payload)
                .catch((error) => {
                    const parsedError = getError(error);
                    if (typeof parsedError === 'object') {
                        this.$refs.form.setErrors(parsedError);
                    }

                    return error.response || { data: {} };
                });

            if (!response?.data?.data?.id) {
                this.saving = false;

                return;
            }

            this.complaint = response.data.data;
            this.saving = false;
        },
        async generate() {
            this.generating = true;
            // Set to false in order to reload iframe
            this.complaint.has_pdf = false;

            await ApiClient.post('/vue/shipping/complaint/' + this.$route.params.id + '/pdf')
                .catch((error) => error.response || { data: {}, status: 500 });

            this.generating = false;
            await this.fetch();
        },
        async send() {
            this.sending = true;

            await ApiClient.post('/vue/shipping/complaint/' + this.$route.params.id + '/send')
                .catch((error) => error.response || { data: {}, status: 500 });

            this.sending = false;
            await this.fetch();
        },
        getInvalidFeedback(errors, key = null) {
            if (key) {
                if (Array.isArray(errors[key]) && errors[key].length) {
                    return errors[key].join(', ');
                }
            }

            if (Array.isArray(errors) && errors.length) {
                return errors.join(', ');
            }

            return null;
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
